export enum Period {
  CUSTOM = 'CUSTOM',
  YEAR = 'YEAR',
  THREE_MONTH = '3MONTH',
  MONTH = 'MONTH',
}
